module.exports = __webpack_public_path__ + "img/new14-1.c658a3d6.jpg";